import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { variantProduct, VariantType } from '../../models/products.model'
import { Subscription } from 'rxjs'
import { ProductsService } from '../../services/products.service'
import { environment } from 'src/environments/environment'
import { ToastrService } from 'ngx-toastr'
import { MatDialog } from '@angular/material/dialog'
import { EditProductVariantComponent } from '../edit-product-variant/edit-product-variant.component'

@Component({
	selector: 'app-product-variance',
	templateUrl: './product-variance.component.html',
	styleUrl: './product-variance.component.scss',
})
export class ProductVarianceComponent implements OnInit, OnDestroy {
	@ViewChild('optionSelect') optionSelect: any
	@Input() countryId: number = 103
	@Input() addMode: boolean = true
	@Input() hasVariants: boolean = true
	@Output() productsVariantsEmitter: EventEmitter<variantProduct[]> =
		new EventEmitter()
	viewMode: boolean = false
	@Input() editMode: boolean = false

	Subscription = new Subscription()
	@Input() variantsData: variantProduct[] = []
	productVariantForm: FormGroup = new FormGroup({})
	variantTypes!: VariantType[]
	attachmentUrl = environment.attachmentPath
	localSku: string[] = []
	constructor(
		public translate: TranslateService,
		private ProductsService: ProductsService,
		private toaster: ToastrService,
		private dialog: MatDialog
	) {}
	ngOnInit(): void {
		this.initForm()
		this.getProductVariantType()
		this.subscribeToDiscount()
	}

	inputChange(event: any) {
		const input = event.target as HTMLInputElement
		this.getController('variantTypeSettings').setValue(input.value)
	}
	changeProductVariantStatus(id: string, isActive: boolean) {
		this.Subscription.add(
			this.ProductsService.changeProductVariantActivationStatus(
				id,
				isActive
			).subscribe()
		)
	}

	initForm() {
		this.productVariantForm = new FormGroup({
			id: new FormControl(0),
			isActive: new FormControl(false),
			variantName: new FormGroup({
				ar: new FormControl('', [Validators.required]),
				en: new FormControl('', [Validators.required]),
			}),
			variantTypeId: new FormControl(null, Validators.required),
			variantTypeSettings: new FormControl(null, Validators.required),
			price: new FormControl('', [Validators.required, Validators.min(1)]),
			stockCount: new FormControl('', [Validators.required, Validators.min(0)]),
			isDiscountFixed: new FormControl(true),
			discountAmount: new FormControl('', [Validators.min(0)]),
			hasLowQuantity: new FormControl(false),
			skuNumber: new FormControl('', [Validators.required]),
			mainImageUrl: new FormControl('', [Validators.required]),
			gallaryImageUrls: new FormControl([], [Validators.required]),
		})
	}

	getController(controlName: string) {
		return this.productVariantForm.controls[controlName]
	}
	getNameFormGroupController(controlName: string) {
		let nameFormgroup = this.productVariantForm.controls
			.variantName as FormGroup
		return nameFormgroup.controls[controlName]
	}
	resetVariantForm() {
		let selectedVariantType =
			this.productVariantForm.getRawValue().variantTypeId

		this.initForm()
		this.getController('variantTypeId')?.patchValue(selectedVariantType, {
			onlySelf: true,
			emitEvent: false,
		})
	}

	checkUnique(event: any) {
		if (event.target.value.length > 0) {
			this.Subscription.add(
				this.ProductsService.isSkuUnique(event.target.value).subscribe(
					(res: any) => {
						res.result
							? this.productVariantForm
									.get('skuNumber')
									?.setErrors({ unique: res.result })
							: this.productVariantForm.get('skuNumber')?.setErrors(null)
						!res.result ? this.localSkuCheck(event) : ''
					}
				)
			)
		} else {
			this.productVariantForm.get('skuNumber')?.setErrors({ required: true })
		}
	}
	localSkuCheck(event: any) {
		if (this.localSku.includes(event.target.value)) {
			this.productVariantForm.get('skuNumber')?.setErrors({ unique: true })
		} else {
			this.productVariantForm.get('skuNumber')?.setErrors(null)
		}
	}
	getProductVariantType() {
		this.Subscription.add(
			this.ProductsService.getProductVariantType().subscribe((res: any) => {
				this.variantTypes = res.result
				if (this.editMode && this.variantsData?.length) {
					let selectedCategoryIndex = 0

					this.variantTypes.filter((ele: any, index) => {
						ele.id == this.variantsData[0]?.variantType?.id
							? (selectedCategoryIndex = index)
							: ''
					})

					this.getController('variantTypeId')?.setValue(
						this.variantTypes[selectedCategoryIndex]
					)
				}
			})
		)
	}

	addNewVariant() {
		this.editMode && !this.hasVariants ? (this.variantsData = []) : null
		let variant = this.productVariantForm.getRawValue()
		let selectedVariantType = variant.variantTypeId
		variant.variantTypeId = variant.variantTypeId.id
		variant.countryId = this.countryId
		this.variantsData.push(variant)
		this.localSku.push(variant.skuNumber)

		this.productsVariantsEmitter.emit(this.variantsData)

		this.toaster.success(
			this.translate.instant('TOASTER.VARIANT_ADDED_SUCCESSFULLY')
		)
		this.initForm()
		this.getController('variantTypeId').setValue(selectedVariantType)
		this.subscribeToDiscount()
	}
	subscribeToDiscount() {
		this.Subscription.add(
			this.productVariantForm.valueChanges.subscribe(() => {
				if (
					this.getController('price')?.value &&
					this.getController('discountAmount')?.value &&
					this.getController('price')?.value <=
						this.getController('discountAmount')?.value &&
					this.getController('isDiscountFixed')?.value
				) {
					this.getController('discountAmount')?.setErrors(null)

					this.getController('discountAmount')?.setErrors({
						discountMoreThanPrice: true,
					})
				} else {
					this.getController('discountAmount')?.errors?.discountMoreThanPrice
						? this.getController('discountAmount').setErrors(null)
						: null
				}

				if (!this.getController('isDiscountFixed')?.value) {
					this.getController('discountAmount')?.setErrors(null)
					this.getController('discountAmount')?.value > 100
						? this.getController('discountAmount')?.setErrors({
								percentageMax: true,
						  })
						: this.getController('discountAmount')?.setErrors(null)
				}
			})
		)
	}
	editVariantDialog(selectedVariant: any, index: number) {
		this.dialog
			.open(EditProductVariantComponent, {
				width: '900px',
				height: '700px',
				data: {
					...selectedVariant,
					index,
					localSku: this.localSku,
					variantTypeId: this.getController('variantTypeId').value,
				},
			})
			.afterClosed()
			.subscribe((res) => {
				if (res?.action) {
					if (res.action == 'edit') {
						delete res.action

						this.variantsData[res?.index] = res
					} else if (res.action == 'delete') {
						this.deleteAtIndex(res?.index)
					}
				}
			})
	}
	deleteAtIndex(index: number) {
		this.variantsData.splice(index, 1)
	}
	deleteImg(deletedImg: any) {
		this.getController('gallaryImageUrls').setValue(
			this.getController('gallaryImageUrls').value.filter(
				(ele: any) => ele !== deletedImg
			)
		)
	}
	ngOnDestroy(): void {
		this.Subscription.unsubscribe()
	}
}
